export default {
  tabs: {
    warranty_settings: false,
    lifetime_warranty: false,
  },
  custom_labels: [
    {
      value: 'subdistributor',
      replacementValue: 'manager',
    },
    {
      value: 'Subdistributor',
      replacementValue: 'Manager',
    },
    {
      value: 'chain',
      replacementValue: 'seller',
    },
    {
      value: 'Chain',
      replacementValue: 'Seller',
    },
    {
      value: 'store_name',
      replacementValue: 'shop name',
    },
  ],
};
